import {createAction, props} from '@ngrx/store';

export const openDetailText = createAction(
    '[ProductDetails] Opened DetailText'
);

export const closeDetailText = createAction(
    '[ProductDetails] Closed DetailText'
);

export const openSafetyText = createAction(
    '[ProductDetails] Opened SafetyText'
);

export const closeSafetyText = createAction(
    '[ProductDetails] Closed SafetyText'
);

export const activateFreeText = createAction(
    '[ProductDetails] Activated FreeText'
);

export const selectedQuantity = createAction(
    '[ProductDetails] Changed Quantity',
    props<{ selectedQuantity: number }>()
);
